import { get } from '../utils/axios'

export const getEmpsSearchLevelAPI = async () => {
  return await get('search/employee-level')
}
